const design_roadmap = [
  {
    id: 1,
    title: 'Book Free consultation',
    description:
      "A quick intro call to understand your needs, goals, and whether we're the right fit.",
    runtime: '45 min',
    icon: 'call-calling',
  },
  {
    id: 2,
    title: 'Kickoff meeting',
    description:
      'A meeting to align stakeholders on the project scope, communication plan, responsibilities, and timeline.',
    runtime: '2 hours',
    icon: 'notification-bing',
  },
  {
    id: 3,
    title: 'Wireframes',
    description:
      'Create low-fidelity wireframes to map structure and interactions.',
    runtime: '2-3 days',
    icon: 'shapes',
  },
  {
    id: 4,
    title: 'Visual Design',
    description: 'Design high-fidelity UI based on approved wireframes.',
    runtime: '14-20 days',
    icon: 'pen-tool',
  },
  {
    id: 5,
    title: 'Interactive Prototype',
    description:
      'Build a clickable prototype in Figma for testing and presentation.',
    runtime: '2 days',
    icon: 'monitor-mobbile',
  },
  {
    id: 6,
    title: 'Handoff & Review',
    description:
      'Final polish, documentation, and walkthrough with client/team.',
    runtime: '3-5 days',
    icon: 'star',
  },
];

const design_team = [
  { id: 1, name: 'Product designer', amount: 1 },
  { id: 2, name: 'Project manager', amount: 1 },
];

const deliverable_1 = [
  { id: 1, name: 'Information architecture' },
  { id: 2, name: 'Interactive high-fidelity prototype (desktop or mobile)' },
  { id: 3, name: 'Core user flows and navigation structure' },
  { id: 4, name: 'Visual style aligned with your brand' },
];

const deliverable_2 = [
  { id: 1, name: 'Basic design system (UI components, typography, colors)' },
  { id: 2, name: 'Figma link for collaboration and handoff' },
  {
    id: 3,
    name: 'Optional: lightweight UX testing with insights (if requested)',
  },
];

const discovery_roadmap = [
  {
    id: 1,
    title: 'Book Free consultation',
    description:
      "A quick intro call to understand your needs, goals, and whether we're the right fit.",
    runtime: '45 min',
    icon: 'call-calling',
  },
  {
    id: 2,
    title: 'Client interview call',
    description:
      'Deep-dive sessions to gather insights about the business context, product vision, end users, and key requirements.',
    runtime: '1 hour',
    icon: 'people',
  },
  {
    id: 3,
    title: 'Competitor analysis',
    description:
      'A detailed review of direct and indirect competitors to identify market gaps, benchmark user experiences, and define unique value propositions for the product.',
    runtime: '2-4 days',
    icon: 'teacher',
  },
  {
    id: 4,
    title: 'High-level system architecture workshop',
    description:
      'A deep collaborative session with the architect, designer, and client to create a shared vision of the system. Together, we define key components, integrations, and user flows to ensure a scalable and cohesive product structure.',
    runtime: '2 hours',
    icon: 'teacher',
  },
  {
    id: 5,
    title: 'Wireframing',
    description:
      'Designing and visualizing the most complex user flows to validate logic, usability, and user experience before moving to detailed UI design.',
    runtime: '1 day',
    icon: 'document-code',
  },
  {
    id: 6,
    title: 'System specification',
    description:
      'Based on the initial data collected, the team defines system modules and user stories, ensuring all required information is documented to conduct the most accurate system estimation at this stage.',
    runtime: '5 days',
    icon: 'document-code',
  },
  {
    id: 7,
    title: 'Project estimation workshop',
    description:
      'During this workshop, we present detailed cost breakdowns for all modules and features. Together with the client, we review and finalize the overall system structure to confirm scope and priorities before development.',
    runtime: '3 hours',
    icon: 'teacher',
  },
];

const discovery_team = [
  { id: 1, name: 'Project manager', amount: 1 },
  { id: 2, name: 'Product manager', amount: 1 },
  { id: 3, name: 'Product designer', amount: 1 },
  { id: 4, name: 'Business analyst', amount: 1 },
  { id: 5, name: 'System architect', amount: 1 },
];

const documents_1 = [
  { id: 1, name: 'User stories' },
  { id: 2, name: 'Releases breakdown' },
  { id: 3, name: 'System architecture' },
  { id: 4, name: 'List of recommended technologies' },
  { id: 5, name: 'Product roadmap' },
  { id: 6, name: 'Product specification' },
  { id: 7, name: '90% accuracy time & cost estimates' },
];

const documents_2 = [
  { id: 1, name: 'Releases breakdown' },
  { id: 2, name: 'System architecture' },
  { id: 3, name: 'List of recommended technologies' },
  { id: 4, name: 'Product roadmap' },
  { id: 5, name: 'Product specification' },
  { id: 6, name: '90% accuracy time & cost estimates ' },
];

export {
  deliverable_1,
  deliverable_2,
  design_roadmap,
  design_team,
  discovery_roadmap,
  discovery_team,
  documents_1,
  documents_2,
};
